import {useQuery} from '@github-ui/react-query'
import {FetchCAPI401Error} from '../utils/fetch-capi'
import {useConsecutiveCAPI401sContext} from '../contexts/ConsecutiveCAPI401sContext'
import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'
import {useEffect} from 'react'

type UseQueryArgs<T> = Parameters<typeof useQuery<T>>

export function useCAPIQuery<T>(...args: UseQueryArgs<T>) {
  const result = useQuery(...args)
  const {numberOf401s, increment401s, reset401s} = useConsecutiveCAPI401sContext()
  const {isError, isLoading, error} = result

  useEffect(() => {
    // Why are we doing this? It's possible for the tokens we use to contact CAPI
    // to become unusable before their actual expiration time. This happens when a user
    // has too many concurrent tokens. This logic clears the cached token if it starts
    // returning 401s, demonstrating it is no longer usable.
    if (isError && error instanceof FetchCAPI401Error) {
      increment401s()
    } else if (!isError && !isLoading) {
      reset401s()
    } else if (numberOf401s > 5) {
      const tokenProvider = new AgentSessionsTokenProvider()
      tokenProvider.removeLocalStorageAuthToken()
      reset401s()
    }
  }, [isError, isLoading, error, increment401s, reset401s, numberOf401s])
  return result
}
